import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import { Logo } from '../../../shared/components/ui/Logo';

export const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-background-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div
              className="mb-3 cursor-pointer"
              onClick={() => {
                navigate('/');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              <Logo width={60} height={30} variant="default" />
            </div>
            <p className="text-text-secondary mb-4 text-sm">
              Your trusted partner for unforgettable safari adventures in
              Tanzania.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="text-text-tertiary hover:text-primary-500 transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="text-text-tertiary hover:text-primary-500 transition-colors"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="text-text-tertiary hover:text-primary-500 transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="text-text-tertiary hover:text-primary-500 transition-colors"
              >
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-text-primary mb-3 text-sm">
              Quick Links
            </h4>
            <ul className="space-y-1">
              <li>
                <Link
                  to="/about"
                  onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/safaris-search"
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  Safari Tours
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold text-text-primary mb-3 text-sm">
              Support
            </h4>
            <ul className="space-y-1">
              <li>
                <Link
                  to="/faq"
                  onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/cancellation"
                  onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  Cancellation Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-text-primary mb-3 text-sm">
              Contact Info
            </h4>
            <ul className="space-y-1 text-text-secondary text-sm">
              <li>123 Safari Street</li>
              <li>Arusha, Tanzania</li>
              <li>Phone: +255 123 456 789</li>
              <li>Email: info@dalarides.com</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border-primary mt-6 pt-2 pb-1 text-center text-text-tertiary text-xs">
          <p className="leading-tight">
            &copy; {new Date().getFullYear()} Dala Rides. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
